function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJoined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 46,
    height: 46,
    rx: 23,
    fill: "url(#paint0_radial_7063_18905)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7063_18905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2715 30.8512C21.2715 28.97 19.7461 27.4447 17.8649 27.4447C15.9837 27.4447 14.4583 28.97 14.4583 30.8512V31.9141H21.2715V30.8512ZM32.209 30.8512C32.209 28.97 30.6837 27.4447 28.8024 27.4447C26.9212 27.4447 25.3958 28.97 25.3958 30.8512V31.9141H32.209V30.8512ZM32.209 15.9294C32.209 14.9111 31.3832 14.0853 30.3649 14.0853H27.2399C26.395 14.0853 25.6846 14.6545 25.4666 15.4297H27.2399L27.3408 15.4395C27.5686 15.4861 27.7396 15.6878 27.7396 15.9294C27.7396 16.1709 27.5686 16.3726 27.3408 16.4193L27.2399 16.429H25.4666C25.6846 17.2043 26.395 17.7734 27.2399 17.7734H30.3649C31.3832 17.7734 32.209 16.9476 32.209 15.9294ZM19.709 24.6012C19.709 23.583 18.8832 22.7572 17.8649 22.7572C16.8466 22.7572 16.0208 23.583 16.0208 24.6012C16.0208 25.5558 16.7465 26.341 17.6761 26.4355L17.8649 26.4453L18.0537 26.4355C18.9833 26.341 19.709 25.5558 19.709 24.6012ZM30.6465 24.6012C30.6465 23.583 29.8207 22.7572 28.8024 22.7572C27.7841 22.7572 26.9583 23.583 26.9583 24.6012C26.9583 25.5558 27.684 26.341 28.6136 26.4355L28.8024 26.4453L28.9912 26.4355C29.9208 26.341 30.6465 25.5558 30.6465 24.6012ZM20.7083 24.6012C20.7083 25.4989 20.2919 26.2985 19.6423 26.8197C21.1902 27.5031 22.2708 29.0503 22.2708 30.8512V32.4137C22.2708 32.6899 22.0473 32.9134 21.7712 32.9134H13.9587C13.6825 32.9134 13.459 32.6899 13.459 32.4137V30.8512C13.459 29.0506 14.5391 27.5032 16.0868 26.8197C15.4374 26.2985 15.0215 25.4987 15.0215 24.6012C15.0215 23.0307 16.2944 21.7578 17.8649 21.7578C19.4355 21.7578 20.7083 23.0307 20.7083 24.6012ZM31.6458 24.6012C31.6458 25.4985 31.2297 26.2977 30.5806 26.8188C32.1283 27.5024 33.2083 29.0505 33.2083 30.8512V32.4137C33.2083 32.6899 32.9848 32.9134 32.7087 32.9134H24.8962C24.62 32.9134 24.3965 32.6899 24.3965 32.4137V30.8512C24.3965 29.0508 25.476 27.5025 27.0234 26.8188C26.3746 26.2977 25.959 25.4983 25.959 24.6012C25.959 23.0307 27.2319 21.7578 28.8024 21.7578C30.373 21.7578 31.6458 23.0307 31.6458 24.6012ZM14.4583 15.9294C14.4583 16.9476 15.2841 17.7734 16.3024 17.7734H19.4274C20.2723 17.7734 20.9827 17.2043 21.2007 16.429H19.4274C19.1513 16.429 18.9277 16.2055 18.9277 15.9294C18.9277 15.6532 19.1513 15.4297 19.4274 15.4297H21.2007C20.9827 14.6545 20.2723 14.0853 19.4274 14.0853H16.3024C15.2841 14.0853 14.4583 14.9111 14.4583 15.9294ZM33.2083 15.9294C33.2083 17.4999 31.9355 18.7728 30.3649 18.7728H27.2399C25.8399 18.7728 24.6775 17.7612 24.4412 16.429H22.2261C21.9898 17.7612 20.8274 18.7728 19.4274 18.7728H16.3024C14.7319 18.7728 13.459 17.4999 13.459 15.9294C13.459 14.3588 14.7319 13.0859 16.3024 13.0859H19.4274C20.8274 13.0859 21.9898 14.0975 22.2261 15.4297H24.4412C24.6775 14.0975 25.8399 13.0859 27.2399 13.0859H30.3649C31.9355 13.0859 33.2083 14.3588 33.2083 15.9294Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7063_18905",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.89447 42.4615) rotate(-41.5346) scale(60.7023 163.609)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D56EB",
    style: {
      stopColor: "#0D56EB",
      stopColor: "color(display-p3 0.0510 0.3373 0.9216)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0640B9",
    style: {
      stopColor: "#0640B9",
      stopColor: "color(display-p3 0.0235 0.2510 0.7255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7063_18905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(13.3335 13)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoined);
export default __webpack_public_path__ + "static/media/joined.251fc3d67dcd3416c7e8b24887a7ab14.svg";
export { ForwardRef as ReactComponent };